 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		32: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		32: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"VipCuratedFolderTooltip","1":"AppStoreLink","2":"AuthModal","3":"AuthProvider","4":"CartNavDropdownContent","5":"Contact1stdibsModal","6":"Contact1stdibsModalAcuityEmbed","7":"Contact1stdibsModalTradeRepCircle","8":"ContactTradeRepModalChunk","9":"FavNotifications","10":"FbpvnyVpbaf","11":"MobileNavAppBanner","12":"MobileVipCuratedFolderCalloutContent","13":"NotificationsBodyComponents","14":"PrivacyPolicyChangeNoticeChunk","15":"TradeEnrollmentAndStatusUpdateLoader","16":"TradeEnrollmentAndStatusUpdateRenderer","17":"TradeExpiringPromoModalChunk","18":"TradeGeneralOnboardingModalChunk","19":"TradePromoModalChunk","20":"TradeRewardsEndOfYearMessaging","21":"TradeRewardsLevelUpModalChunk","22":"TradeRewardsNavigationTooltip","23":"TradeVerifyFirmReminderToast","24":"VipCuratedFolderTooltipContent","25":"abandonCheckoutAutoModal","26":"abandonCheckoutPreAuthOfferMessageModal","27":"backToTop","28":"chat","29":"checkoutSurvey","30":"contactDealerModal","31":"cookieNotification","33":"intlClientPolyfill","34":"makeOfferModal","35":"mobileFooter","36":"mobileHeader","37":"responsiveFooter","38":"responsiveHeader","39":"tradeAccountNavContent"}[chunkId]||chunkId) + "-legacy-buyer-64a4377e-0cdd-4fac-a735-09cbcd6ab348-" + "06214ab294ae0da80b64" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"3":1,"5":1,"7":1,"8":1,"9":1,"11":1,"12":1,"13":1,"14":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"VipCuratedFolderTooltip","1":"AppStoreLink","2":"AuthModal","3":"AuthProvider","4":"CartNavDropdownContent","5":"Contact1stdibsModal","6":"Contact1stdibsModalAcuityEmbed","7":"Contact1stdibsModalTradeRepCircle","8":"ContactTradeRepModalChunk","9":"FavNotifications","10":"FbpvnyVpbaf","11":"MobileNavAppBanner","12":"MobileVipCuratedFolderCalloutContent","13":"NotificationsBodyComponents","14":"PrivacyPolicyChangeNoticeChunk","15":"TradeEnrollmentAndStatusUpdateLoader","16":"TradeEnrollmentAndStatusUpdateRenderer","17":"TradeExpiringPromoModalChunk","18":"TradeGeneralOnboardingModalChunk","19":"TradePromoModalChunk","20":"TradeRewardsEndOfYearMessaging","21":"TradeRewardsLevelUpModalChunk","22":"TradeRewardsNavigationTooltip","23":"TradeVerifyFirmReminderToast","24":"VipCuratedFolderTooltipContent","25":"abandonCheckoutAutoModal","26":"abandonCheckoutPreAuthOfferMessageModal","27":"backToTop","28":"chat","29":"checkoutSurvey","30":"contactDealerModal","31":"cookieNotification","33":"intlClientPolyfill","34":"makeOfferModal","35":"mobileFooter","36":"mobileHeader","37":"responsiveFooter","38":"responsiveHeader","39":"tradeAccountNavContent"}[chunkId]||chunkId) + "-legacy-buyer-64a4377e-0cdd-4fac-a735-09cbcd6ab348-" + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"ecd4ca7eda1edad29fdb","3":"deaffed95486a0702768","4":"31d6cfe0d16ae931b73c","5":"c0bf11787d069791b856","6":"31d6cfe0d16ae931b73c","7":"93b82c93591599cd2de4","8":"6a429c97b81995726828","9":"1bb478a0efd3b6bd58cf","10":"31d6cfe0d16ae931b73c","11":"8f8d5bc58bd2d529086f","12":"b5c52e6a9d215f2fc30c","13":"704e49c78333373c711d","14":"43ec7775a88f28b981fa","15":"31d6cfe0d16ae931b73c","16":"01534d8653a215104f1f","17":"1bc848c0c004c6b775e4","18":"9d7e662c14a19e17d7b4","19":"9431b6bd40d953f63da4","20":"119d4a60d8f567fe1854","21":"01dac8b950de9b2e2ff6","22":"4f832c27cee4ad099df8","23":"4352e0aa981c279fde3a","24":"417cdbbc9f2f0e413ee9","25":"152ba357128488232d56","26":"50b7a22a9f49167b2393","27":"d05b3b4e38deb58f5866","28":"693cde6f1e8fb6729fbf","29":"0d22d8e317c835ee2feb","30":"3a35430338ea6101bfc4","31":"743a4d4329af6c7e7043","33":"31d6cfe0d16ae931b73c","34":"1d8c9763745b2313b782","35":"41982174ac8ab9236744","36":"ff0ad86e89281f2ebeb2","37":"f9011f96c805adf0cdd4","38":"983bb9e746ba9a5d28a6","39":"d0f480641274617ecff4"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://a.1stdibscdn.com/dist/dibs-buyer-layout/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpwindow_dibs_buyer_layout_buyer"] = window["webpackJsonpwindow_dibs_buyer_layout_buyer"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
